function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Divider } from "../Divider/index.js";
import { Icon } from "../Icon/index.js";
import { Link } from "../Link/index.js";
import { Typography } from "../Typography/index.js";
import { cn } from "../../common/helpers.js";
const isLink = (b)=>b.href !== undefined;
function Heading(props) {
    const { heading, slots = {}, slotProps = {} } = props;
    var _slotProps_heading;
    const _ref = (_slotProps_heading = slotProps.heading) !== null && _slotProps_heading !== void 0 ? _slotProps_heading : {}, { className: headingClassName, label: headingChildren } = _ref, restHeadingSlotsProps = _object_without_properties(_ref, [
        "className",
        "label"
    ]);
    if (slots.heading) {
        const HeadingSlotComponent = slots.heading;
        return /*#__PURE__*/ _jsx(HeadingSlotComponent, _object_spread_props(_object_spread({}, slotProps.heading), {
            children: headingChildren
        }));
    }
    if (typeof heading === 'object' && isLink(heading)) {
        const { label } = heading, restHeading = _object_without_properties(heading, [
            "label"
        ]);
        return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
            noUnderline: true,
            className: cn('font-bold text-lg', headingClassName)
        }, restHeading, restHeadingSlotsProps), {
            children: label
        }));
    }
    return /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({
        variant: "h4",
        as: "h3",
        className: cn('font-medium', headingClassName)
    }, restHeadingSlotsProps), {
        children: headingChildren !== null && headingChildren !== void 0 ? headingChildren : heading
    }));
}
/**
 * Decorated List Item - [API](https://scl.sharp.com/?path=/docs/components-decoratedlistitem) | [DSM](https://sharphealthcare.notion.site/List-item-e0afbc4b9f8e40b8a9e8fcf421a33b65)
 */ const DecoratedListItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { heading, description, decorator, slots = {}, slotProps = {}, as } = props, rest = _object_without_properties(props, [
        "heading",
        "description",
        "decorator",
        "slots",
        "slotProps",
        "as"
    ]);
    const Root = as !== null && as !== void 0 ? as : 'div';
    var _slots_headingContainer;
    const HeadingContainer = (_slots_headingContainer = slots.headingContainer) !== null && _slots_headingContainer !== void 0 ? _slots_headingContainer : 'div';
    var _slotProps_headingContainer;
    const _ref = (_slotProps_headingContainer = slotProps.headingContainer) !== null && _slotProps_headingContainer !== void 0 ? _slotProps_headingContainer : {}, { className: headingContainerClassName } = _ref, restOfHeadingContainerProps = _object_without_properties(_ref, [
        "className"
    ]);
    var _slots_description;
    // description
    const Description = (_slots_description = slots.description) !== null && _slots_description !== void 0 ? _slots_description : Typography;
    var _slotProps_description;
    const _ref1 = (_slotProps_description = slotProps.description) !== null && _slotProps_description !== void 0 ? _slotProps_description : {}, { className: descriptionClassNameSlotProps, children: descriptionChildren } = _ref1, restDescriptionSlotProps = _object_without_properties(_ref1, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread({
        ref: ref,
        className: "mb-6",
        role: "listitem"
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                className: "mb-6"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-x-5 mb-2",
                children: [
                    decorator && /*#__PURE__*/ _jsx("div", {
                        className: "rounded-full h-10 w-10 bg-primary-50 flex flex-shrink-0 items-center justify-center",
                        children: typeof decorator === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                            variant: "body-semibold",
                            children: decorator
                        }) : /*#__PURE__*/ _jsx(Icon, _object_spread({
                            className: "text-primary"
                        }, decorator))
                    }),
                    /*#__PURE__*/ _jsx(HeadingContainer, _object_spread_props(_object_spread({
                        className: cn('my-auto', headingContainerClassName)
                    }, restOfHeadingContainerProps), {
                        children: /*#__PURE__*/ _jsx(Heading, {
                            heading: heading,
                            slots: slots,
                            slotProps: slotProps
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-x-5",
                children: [
                    decorator && /*#__PURE__*/ _jsx("div", {
                        className: "w-10 flex flex-shrink-0"
                    }),
                    description && /*#__PURE__*/ _jsx(Description, _object_spread_props(_object_spread({
                        variant: "body",
                        className: cn('scl-rich-text', descriptionClassNameSlotProps)
                    }, restDescriptionSlotProps), {
                        children: description !== null && description !== void 0 ? description : descriptionChildren
                    }))
                ]
            })
        ]
    }));
});
export { DecoratedListItem };
